import { render, staticRenderFns } from "./QuickReplies.old.vue?vue&type=template&id=3947ac86&"
import script from "./QuickReplies.old.vue?vue&type=script&lang=js&"
export * from "./QuickReplies.old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports